export default class newsLetterForm {
  constructor() {
    $(document).ready(function(){
      // var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (window.innerWidth >= 992) {
       $('#cashback-offers').addClass('cashback-offers');
      }
      });
    $("form").attr('autocomplete', 'off');    
    $('.news-letter-form input[type="submit"]').attr('disabled','disabled');
    $('.de-news-letter-popup input[type="submit"]').removeAttr('disabled','disabled');
    var searchRequest = null;
    var isInvalidEmail = true;
    $(function(){
      $('.news-letter-form input[type="email"]').on('blur', function(e) {
        var bodyPadTop = $("body").css('padding-top');
        $("body").css('padding-top','0');
        $("body").css('padding-top',bodyPadTop);
      });
      $('footer .news-letter-form input[type="email"]').on('keyup', function(e) {
        var fieldVal = $(this).val();
        var keyVal = e.keyCode;
        if(keyVal != 13){
          checkEmailExists(fieldVal);
        } 
      });
      function isValidEmailAddress(emailAddress) {
          var pattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$\.?$/i;
          return pattern.test(emailAddress);
      }
      function checkEmailExists(value){
        var isEmailCheck = isValidEmailAddress(value);
        var wffmFormId = $('.news-letter-form').attr('data-wffm');          
        if (isEmailCheck) {
          if (searchRequest != null) 
              searchRequest.abort();
          searchRequest = $.ajax({
              type: "GET",
              url: "/api/Newsletter/AlreadyExist",
              data: {
                  'wffmEmail' : value,
                  'wffmID' : wffmFormId
              },
              dataType: "text",
              async: false,
              success: function(msg){
                if(msg == 'Yes'){
                  $('.news-letter-form input[type="submit"]').attr('disabled','disabled');
                  if(!$('.news-letter-form *').hasClass('emailExistsError')){
                    $(".news-letter-form .single-line").after("<span class='emailExistsError'>Email already in subscription list.</span>");
                  }
                  isInvalidEmail = true;
                }else{
                  $('.news-letter-form input[type="submit"]').removeAttr('disabled');
                  $(".emailExistsError").remove();
                  isInvalidEmail = false;
                }
              }
          });
        }else{
          $(".emailExistsError").remove();
        }
      }
      $('.header-news-letter-form').attr('href','#');
      var wffmFormContent = $('header .news-letter-form').html();      
      $('.header-news-letter-form').click(function(event){
        $('.header-news-letter-form').toggleClass('showCaret');
        $('header .news-letter-form').html('');
        $('header .news-letter-form').html(wffmFormContent);
        $('header .news-letter-form input[type="email"]').on('keyup', function(e) {
          var emailFieldVal = $(this).val();
          var keyVal = e.keyCode;
          if(keyVal != 13){
            checkEmailExists(emailFieldVal);
          }
        });
        $('header .news-letter-form').toggle();
        var objDiv = document.getElementById("site-menu");
        objDiv.scrollTop = objDiv.scrollHeight;
        event.stopPropagation();
      });
      $('header .news-letter-form').submit(function( event ) {
        var $target = $(event.target);
        var error = $target.find('.required-field.has-error');
        if( !error.length ) {
            $('header .news-letter-form input.btn').attr('disabled', 'disabled');
        }
      });
      $('.news-letter-form').on('keypress',function(e){
        var buttonCode = e.keyCode;
        if(isInvalidEmail && buttonCode == 13){
          e.preventDefault();
		  return false;
        }
      });
	  var getTokenValue = function getTokenValue(sParam) {
		var sPageURL = decodeURIComponent(window.location.search.substring(1)),
		sURLVariables = sPageURL.split('&'),
		sParameterName,
		i;
		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	  };
	  var validationToken = getTokenValue("validationToken");
	  if(validationToken != null && validationToken != undefined){
		var cookieValue= document.cookie;
		if(document.cookie.includes(validationToken)){
			$('.update-password-form').html("This Page Cannot Be Displayed");		
		}
	  }
	  $('.update-password-form').submit(function( event ) {
		var $target = $(event.target);
		var interval;
		var error = $target.find('.required-field.has-error');
		if( !error.length ) {
			$('.update-password-form input.btn').attr('disabled', 'disabled');
			interval = setInterval(function() {
				var thankyou = $target.find('.update-password-form');
				if( thankyou.length ) {
					document.cookie = validationToken;
					clearInterval(interval);
				}
			},10)
		}
		event.preventDefault();
	  });
       
      //For contact-us form submission succcess message focus issue fix  
	  $('.contact-brand').submit(function( event ) {
	      var $target = $(event.target);
	      var interval;
	      var error = $target.find('.required-field.has-error');
	      if( !error.length ) {
	          $('.contact-brand input.btn').attr('disabled', 'disabled');
	          interval = setInterval(function() {
	              var successMsg = $target.find('.contact-us-success-msg');
	              if( successMsg.length ) { 
	                  $('html, body').animate({ scrollTop: 0 }, 'slow');
	                  clearInterval(interval);
	              }
	          },10)
	      }
	      event.preventDefault();
	  });  
    });
    this.init();
  }

  init () {      
    $(window).on("orientationchange load", function(){
      var curWinWidth = $(window).width();
      //var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if(curWinWidth < 992){
        $('header .news-letter-form').detach().appendTo('header .navbar-nav ul.header-right ul.icons-right li');
      }else{
        $('header .navbar-nav ul.header-right ul li .news-letter-form').detach().insertAfter("header .first-row");
      }
      if(curWinWidth > 1023){        
        $(window).click(function() {
          $('.header-news-letter-form').removeClass('showCaret');
          $('header .news-letter-form').hide();
        });
        $('header .news-letter-form').click(function(event){
          event.stopPropagation();
        });
      }else{
        $('.navbar-toggle').click(function() {
          $('.header-news-letter-form').removeClass('showCaret');
          $('header .news-letter-form').hide();          
          var objDiv = document.getElementById("site-menu");
          objDiv.scrollTop = 0;
          $('body').css('padding-top','110px');
        });
      }	
    });
    var formShow = true;
    var winWidth = $(window).width();
    $(window).scroll(function (event) {
      if($("header .navbar").hasClass("sticky") && winWidth > 1023){
        $('.header-news-letter-form').removeClass('showCaret');
        $('header .news-letter-form').hide();
      }
      var winHeight = $(window).height();
      var scrollTop = $(window).scrollTop();
      if(scrollTop > winHeight && formShow){
        $('footer .news-letter-form').fadeIn();
        $('footer .news-letter-form .page-header h1').append('<span class="closebutton pull-right">&times;</span>');
        formShow = false;
        $('footer .news-letter-form').submit(function( event ) {
          var $target = $(event.target);
          var interval;
          var error = $target.find('.required-field.has-error');
          if( !error.length ) {
              $('footer .news-letter-form input.btn').attr('disabled', 'disabled');
              interval = setInterval(function() {
                  var thankyou = $target.find('.news-letter-form');
                  if( thankyou.length ) {
                      $('footer .news-letter-form .page-header h1').append('<span class="closebutton pull-right">&times;</span>');
                      clearInterval(interval);
                  }
              },10)
          }
          event.preventDefault();
        });
      }
    });
    $('body').on('click', 'footer .news-letter-form .closebutton', (event) => {
      event.preventDefault();
      $('footer .news-letter-form').fadeOut();
    });

    //For contact-us form submission succcess message focus issue fix  
    $('.contact-brand').submit(function( event ) {
        var $target = $(event.target);
        var interval;
        var error = $target.find('.required-field.has-error');
        if( !error.length ) {
            $('.contact-brand input.btn').attr('disabled', 'disabled');
            interval = setInterval(function() {
                var successMsg = $target.find('.contact-us-success-msg');
                if( successMsg.length ) { 
                    $('html, body').animate({ scrollTop: 0 }, 'slow');
                    clearInterval(interval);
                }
            },10)
        }
        event.preventDefault();
    }); 
  }
}
